import React from "react";
import { getOrderStatus, getOrderStatusTone } from "../../../helpers/order.helper";
import { Badge } from "./StatusBadge.styles";

interface StatusBadgeProps {
  status: string;
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  return <Badge $tone={getOrderStatusTone(status)}>{getOrderStatus(status)}</Badge>;
}
